
import { defineComponent, PropType } from 'vue';
import { IBusRoute } from '@/types/api/bus';

export default defineComponent({
  name: 'BusInfoCard',
  props: {
    routeInfo: {
      type: Object as PropType<IBusRoute>,
      default: () => ({})
    }
  },
  setup() {
    return {}
  },
})
